export function formatDrops(n: number): string {
  if (n >= 10_000_000) return `${(n / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`
  return n.toLocaleString()
}
